var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBjsTypeLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.531,
    height: 10,
    viewBox: "0 0 24.531 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7,10c2.2,0,3.827-.988,3.827-2.864,0-2.111-2.272-2.9-3.605-3.37-1.148-.4-1.592-.593-1.592-.975,0-.321.333-.654,1.173-.654a1.4,1.4,0,0,1,1.432.778.4.4,0,0,0,.42.333h1.716A.34.34,0,0,0,24.4,2.9C24.272,1.173,22.7,0,20.457,0c-2.2,0-3.766,1.148-3.766,2.988,0,1.988,2.012,2.729,3.543,3.235,1.161.4,1.642.642,1.642,1.049,0,.284-.3.593-1.222.593a1.684,1.684,0,0,1-1.543-.617c-.148-.259-.21-.321-.494-.321H16.951a.34.34,0,0,0-.321.346C16.8,9.037,18.519,10,20.7,10M13.642,6.21c0,1.148-.494,1.407-1.21,1.407-.642,0-1.222-.259-1.222-1.407V5.7a.3.3,0,0,0-.3-.3H9.037a.3.3,0,0,0-.3.3v.543A3.49,3.49,0,0,0,12.432,10,3.437,3.437,0,0,0,16.1,6.247V.481a.3.3,0,0,0-.3-.3H13.938a.3.3,0,0,0-.3.3V6.21ZM5.42,3.2c0,.457-.247.766-.914.766H2.716a.248.248,0,0,1-.247-.247V2.679a.248.248,0,0,1,.247-.247H4.642A.7.7,0,0,1,5.42,3.2m.432,3.519c0,.506-.247.864-.914.864H2.716a.248.248,0,0,1-.247-.247v-1.2a.248.248,0,0,1,.247-.247H4.938c.667,0,.914.333.914.827m-.642,3.1c1.951,0,3.136-1.124,3.136-2.716A2.227,2.227,0,0,0,6.963,4.963a.124.124,0,0,1-.012-.222,2.178,2.178,0,0,0,.963-1.9C7.913,1.309,6.864.185,4.79.185H.3a.3.3,0,0,0-.3.3V9.519a.3.3,0,0,0,.3.3Z",
    transform: "translate(-5)",
    fill: "#feba30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBjsTypeLogo);
export default __webpack_public_path__ + "static/media/BJSTypeLogo.24b488c14e1b12c61cc963d9693953e0.svg";
export { ForwardRef as ReactComponent };